const root = 'UserRequestDataForm'

export const TestId = {
  root,
  cardHeader: `${root}-cardHeader`,
  submitButton: `${root}-submitButton`,
  successMessage: `${root}.successMessage`,
}
